import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconZip"><Path d="M11 16V15H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 3V21H3L3.00006 3.00001L21 3ZM9 5V7H15V5H9ZM9 9H15V11H9V9ZM9 13V16C9 17.6569 10.3431 19 12 19C13.6569 19 15 17.6569 15 16V13H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZip;
